import { BADGES } from "../../constants/badges";
import { findSkinInfoByName } from "./skinPickerUtils";

const CATEGORY_RULES = [
  ["sport", /(sport|football|soccer|basket|volley|badminton|tennis|padel|running|jog|fitness|gym|yoga|šport|sportov|futbal|basketbal|volejbal|bedminton|tenis|behan|joga|трениров|спорт|футбол|баскетбол|волейбол|теннис|йога)/i],
  ["party", /(party|rave|club|dance|dancing|nightlife|párty|diskot|tanec|tancov|вечерин|танц|клуб)/i],
  ["traveling", /(travel|trip|tour|hike|hiking|journey|cestov|výlet|turistik|túra|поездк|путешеств|поход|туризм)/i],
  ["education", /(workshop|course|learn|lecture|talk|class|lesson|škola|kurz|vzdeláv|prednášk|učen|обучен|лекц|мастер.класс|урок)/i],
  ["recreation", /(coffee|cafe|picnic|cinema|movie|book|board.game|meetup|meet|friend|káva|kaviareň|piknik|kino|kniha|stolov|stretn|кофе|пикник|кино|книг|встреч|настол)/i],
];

const SUGGESTED_BADGE_BY_CATEGORY = {
  sport: ["sport", "ball", "running"],
  party: ["party", "disco-ball", "night-club"],
  traveling: ["travelling", "hiking", "suitcase"],
  education: ["book", "teacher", "brainstorm"],
  recreation: ["meetup", "cafe", "people-table"],
  other: ["meetup", "people-table", "question"],
};

export const suggestQuickConceptCategory = (text) => {
  const normalized = String(text || "").normalize("NFKC");
  return CATEGORY_RULES.find(([, pattern]) => pattern.test(normalized))?.[0] || "other";
};

export const getQuickConceptBadges = (skins, category) => {
  const available = BADGES.map((badge) => {
    const skin = findSkinInfoByName(skins, badge.id);
    return skin && (skin.is_default || skin.owned)
      ? { ...badge, dbId: skin.id }
      : null;
  }).filter(Boolean);
  const preferred = SUGGESTED_BADGE_BY_CATEGORY[category] || SUGGESTED_BADGE_BY_CATEGORY.other;
  return [...available].sort((a, b) => {
    const ai = preferred.indexOf(a.id);
    const bi = preferred.indexOf(b.id);
    return (ai < 0 ? 999 : ai) - (bi < 0 ? 999 : bi);
  });
};

export const matchQuickConceptCity = (cities, cityName, municipalityId) => {
  const items = Array.isArray(cities) ? cities : [];
  const byId = municipalityId && items.find(
    (city) => String(city.municipality_id) === String(municipalityId)
  );
  if (byId) return byId;
  const normalize = (value) => String(value || "").normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
  return items.find((city) => normalize(city.name) === normalize(cityName)) || null;
};

export const buildQuickConceptPayload = ({ title, description, city, badge, mapMarker, gender, age, maxParticipants = 15 }) => {
  const params = new URLSearchParams();
  const values = {
    type: "concept",
    quick_concept: 1,
    name: title.trim(),
    description: description.trim(),
    event_format: 1,
    host_format: 0,
    max_participants: maxParticipants,
    pricing_model: "free",
    fee_type: 0,
    join_by_request: 0,
    audience_mode: "open",
    target_gender: gender || "",
    target_age_min: age?.min || "",
    target_age_max: age?.max || "",
    min_vault_level: 1,
    recurrence_frequency: "none",
    latitude: city.latitude,
    longitude: city.longitude,
    country: city.country,
    city: city.name,
    publication_municipality_id: city.municipality_id || "",
    // A city-centre pin is approximate. Do not turn it into a street address.
    address: "",
    badge_label_id: badge.dbId,
    map_label_id: mapMarker?.id || "",
  };
  Object.entries(values).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) params.append(key, value);
  });
  return params;
};
